@if (order.ultimateBeneficialOwnershipRequest?.questions?.length) {
  <mat-card class="results-content card-margin">
    <div class="margin-top-15">
      @for (question of order.ultimateBeneficialOwnershipRequest?.questions; track question; let i = $index) {
        <div class="flex-item padding">
          <div class="risk-title bold">
            {{ i + 1 }}. <span [innerHTML]="$safeNavigationMigration(question?.question)"></span> @if (question.isRequired) {
            <span class="required"> *</span>
          }
        </div>
        <div class="risk-answer margin-sides-25 margin-top-15">
          {{ question?.answer }}
        </div>
      </div>
    }
  </div>
</mat-card>
} @else {
  <mat-card class="results-content card-margin">
    <div class="empty-state">
      <mat-icon>help_outline</mat-icon>
      <span>{{ 'uboFinancialRiskQuestions.noFinancialRiskQuestionsAreAssociated' | transloco }}</span>
    </div>
  </mat-card>
}

